<template>
  <v-dialog
    :value="visible"
    @input="$emit('update:visible', $event)"
    max-width="680"
    persistent
    content-class="week-form-dialog"
  >
    <v-card class="week-form-card">
      <!-- Header -->
      <div class="wf-header">
        <div class="wf-header-left">
          <div
            class="wf-header-icon"
            :class="
              mode === 'add' ? 'wf-header-icon--add' : 'wf-header-icon--edit'
            "
          >
            <v-icon color="white" size="20">
              {{
                mode === "add"
                  ? "mdi-plus-circle-outline"
                  : "mdi-pencil-outline"
              }}
            </v-icon>
          </div>
          <div>
            <h3 class="wf-title">
              {{
                mode === "add"
                  ? "Agregar Semana Adicional"
                  : `Editar ${weekName}`
              }}
            </h3>
            <span class="wf-subtitle">
              {{
                mode === "add"
                  ? "Configura los turnos para la nueva semana"
                  : "Redistribuye los turnos de esta semana"
              }}
            </span>
          </div>
        </div>
        <v-btn icon small @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-divider />

      <div class="wf-body">
        <!-- Period selector (only for add mode) -->
        <div v-if="mode === 'add'" class="wf-period-selector">
          <label class="wf-field-label">Seleccionar Semana</label>
          <s-periods
            label=""
            v-model="localPdsID"
            :year="periodYear"
            :type="1"
            clearable
            @input="onPeriodChange"
          />
          <span v-if="periodError" class="wf-field-error">{{
            periodError
          }}</span>
        </div>

        <!-- BEFORE panel (only in edit mode) -->
        <div
          v-if="mode === 'edit' && beforeSnapshot.length > 0"
          class="wf-before-panel"
        >
          <div class="wf-panel-label">
            <v-icon x-small color="#94a3b8" class="mr-1"
              >mdi-clock-outline</v-icon
            >
            Estado Actual
          </div>
          <div class="wf-before-grid">
            <div
              v-for="snap in beforeSnapshot"
              :key="snap.TypeTurn"
              class="wf-before-item"
            >
              <v-icon
                x-small
                class="mr-1"
                :color="
                  snap.TypeTurn == 1
                    ? '#f59e0b'
                    : snap.TypeTurn == 2
                    ? '#6366f1'
                    : '#10b981'
                "
              >
                {{
                  snap.TypeTurn == 1
                    ? "mdi-weather-sunny"
                    : snap.TypeTurn == 2
                    ? "mdi-weather-night"
                    : "mdi-swap-horizontal"
                }}
              </v-icon>
              <span class="before-turn-name"
                >{{ getTurnName(snap.TypeTurn) }}:</span
              >
              <span class="before-turn-qty">{{ snap.WprQuantityProject }}</span>
              <span class="before-turn-split"
                >(H:{{ snap.WprQuantityMale }} / M:{{
                  snap.WprQuantityFemale
                }})</span
              >
            </div>
            <div class="wf-before-total">
              Total: <strong>{{ beforeTotal }}</strong>
            </div>
          </div>
        </div>

        <!-- EDITABLE TURNS TABLE -->
        <div class="wf-edit-section">
          <div class="wf-edit-header">
            <span class="wf-panel-label">
              <v-icon x-small color="#3b5bdb" class="mr-1"
                >mdi-tune-variant</v-icon
              >
              {{ mode === "add" ? "Distribución" : "Ajuste Nuevo" }}
            </span>
            <v-btn
              x-small
              outlined
              color="primary"
              class="add-turn-btn"
              @click="addTurn"
              :disabled="localTurns.length >= 3"
            >
              <v-icon x-small class="mr-1">mdi-plus</v-icon>
              Agregar Turno
            </v-btn>
          </div>

          <table class="wf-turns-table">
            <thead>
              <tr>
                <th class="text-left" style="width: 140px">Turno</th>
                <th class="text-center">Hombres</th>
                <th class="text-center">Mujeres</th>
                <th class="text-center">Total</th>
                <th style="width: 44px"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(turn, index) in localTurns"
                :key="index"
                class="wf-turn-row"
              >
                <td>
                  <s-select-definition
                    :showLabel="false"
                    :def="1278"
                    v-model="turn.TypeTurn"
                    dense
                    outlined
                    hide-details
                  />
                </td>
                <td>
                  <v-text-field
                    v-model.number="turn.WprQuantityMale"
                    type="number"
                    min="0"
                    dense
                    outlined
                    hide-details
                    class="wf-qty-input"
                    @input="onMaleChange(turn)"
                  />
                </td>
                <td>
                  <v-text-field
                    v-model.number="turn.WprQuantityFemale"
                    type="number"
                    min="0"
                    dense
                    outlined
                    hide-details
                    class="wf-qty-input"
                    @input="onFemaleChange(turn)"
                  />
                </td>
                <td class="text-center">
                  <span class="wf-turn-total">{{ getTurnTotal(turn) }}</span>
                </td>
                <td class="text-center">
                  <v-btn
                    icon
                    x-small
                    color="error"
                    @click="removeTurn(index)"
                    :disabled="localTurns.length <= 1"
                    title="Eliminar turno"
                  >
                    <v-icon x-small>mdi-close</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="wf-totals-footer">
                <td class="font-weight-bold">Total Semana</td>
                <td class="text-center font-weight-bold">{{ newTotalMale }}</td>
                <td class="text-center font-weight-bold">
                  {{ newTotalFemale }}
                </td>
                <td class="text-center">
                  <span
                    class="wf-grand-total"
                    :class="{ 'wf-grand-over': newGrandTotal > reqQuantity }"
                  >
                    {{ newGrandTotal }}
                  </span>
                </td>
                <td></td>
              </tr>
            </tfoot>
          </table>

          <!-- Limit indicator -->
          <div class="wf-limit-bar">
            <div
              class="wf-limit-fill"
              :style="{ width: limitPercent + '%' }"
              :class="{
                'wf-limit-fill--ok': newGrandTotal <= reqQuantity,
                'wf-limit-fill--over': newGrandTotal > reqQuantity,
              }"
            ></div>
          </div>
          <div class="wf-limit-text">
            <span
              >{{ newGrandTotal }} / {{ reqQuantity }} vacantes por semana</span
            >
            <v-chip
              x-small
              :color="
                newGrandTotal > reqQuantity
                  ? 'error'
                  : newGrandTotal === reqQuantity
                  ? 'success'
                  : 'warning'
              "
              outlined
            >
              {{
                newGrandTotal > reqQuantity
                  ? "Excede"
                  : newGrandTotal === reqQuantity
                  ? "Completo"
                  : "Parcial"
              }}
            </v-chip>
          </div>
        </div>

        <!-- COMPARISON PANEL (edit mode only) -->
        <div v-if="mode === 'edit' && hasChanges" class="wf-comparison-panel">
          <div class="wf-panel-label">
            <v-icon x-small color="#f59e0b" class="mr-1"
              >mdi-swap-horizontal-bold</v-icon
            >
            Comparación de Cambios
          </div>
          <div class="wf-comparison-grid">
            <div
              v-for="diff in changeDiffs"
              :key="diff.turnName"
              class="wf-diff-item"
            >
              <span class="diff-turn">{{ diff.turnName }}</span>
              <span class="diff-before">{{ diff.before }}</span>
              <v-icon x-small color="#94a3b8" class="mx-1"
                >mdi-arrow-right</v-icon
              >
              <span class="diff-after">{{ diff.after }}</span>
              <v-chip
                x-small
                :color="
                  diff.delta > 0
                    ? 'success'
                    : diff.delta < 0
                    ? 'error'
                    : 'default'
                "
                outlined
                class="ml-1"
              >
                {{ diff.delta > 0 ? "+" : "" }}{{ diff.delta }}
              </v-chip>
            </div>
            <div class="wf-diff-total">
              <span class="diff-turn font-weight-bold">Total</span>
              <span class="diff-before">{{ beforeTotal }}</span>
              <v-icon x-small color="#94a3b8" class="mx-1"
                >mdi-arrow-right</v-icon
              >
              <span class="diff-after font-weight-bold">{{
                newGrandTotal
              }}</span>
              <v-chip
                x-small
                :color="
                  totalDelta > 0
                    ? 'success'
                    : totalDelta < 0
                    ? 'error'
                    : 'default'
                "
                outlined
                class="ml-1"
              >
                {{ totalDelta > 0 ? "+" : "" }}{{ totalDelta }}
              </v-chip>
            </div>
          </div>
        </div>

        <!-- New record note (add mode) -->
        <div v-if="mode === 'add'" class="wf-new-note">
          <v-icon x-small color="#3b5bdb" class="mr-1"
            >mdi-information-outline</v-icon
          >
          Nuevo registro — sin valores previos
        </div>
      </div>

      <v-divider />

      <!-- Footer -->
      <div class="wf-footer">
        <v-btn outlined color="grey darken-1" class="wf-btn" @click="close">
          Cancelar
        </v-btn>
        <v-btn
          color="primary"
          class="wf-btn wf-btn--save"
          :disabled="!isValid"
          @click="save"
        >
          <v-icon small class="mr-1">mdi-content-save-outline</v-icon>
          Guardar Cambios
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import SPeriods from "@/components/Utils/SPeriods.vue";

export default {
  name: "WeekFormModal",
  components: { SPeriods },
  props: {
    visible: { type: Boolean, default: false },
    mode: { type: String, default: "edit" }, // 'edit' | 'add'
    weekData: { type: Object, default: () => ({}) },
    weekName: { type: String, default: "" },
    reqQuantity: { type: Number, default: 0 },
    periodYear: { type: Number, default: () => new Date().getFullYear() },
    periodsList: { type: Array, default: () => [] },
    reqId: { type: [Number, String], default: 0 },
    reqID: { type: [Number, String], default: 0 },
  },
  data() {
    return {
      localTurns: [],
      localPdsID: null,
      beforeSnapshot: [],
      periodError: "",
    };
  },
  computed: {
    computedReqId() {
      return Number(this.reqId || this.reqID) || 0;
    },
    newTotalMale() {
      return this.localTurns.reduce(
        (sum, t) => sum + (Number(t.WprQuantityMale) || 0),
        0,
      );
    },
    newTotalFemale() {
      return this.localTurns.reduce(
        (sum, t) => sum + (Number(t.WprQuantityFemale) || 0),
        0,
      );
    },
    newGrandTotal() {
      return this.localTurns.reduce((sum, t) => sum + this.getTurnTotal(t), 0);
    },
    beforeTotal() {
      return this.beforeSnapshot.reduce(
        (sum, s) => sum + (Number(s.WprQuantityProject) || 0),
        0,
      );
    },
    limitPercent() {
      if (!this.reqQuantity) return 0;
      return Math.min(100, (this.newGrandTotal / this.reqQuantity) * 100);
    },
    hasChanges() {
      if (this.mode !== "edit") return false;
      // Compare current turns vs snapshot
      const allTurnTypes = new Set([
        ...this.beforeSnapshot.map((s) => Number(s.TypeTurn)),
        ...this.localTurns.map((t) => Number(t.TypeTurn)),
      ]);
      for (const tt of allTurnTypes) {
        const before = this.beforeSnapshot.find(
          (s) => Number(s.TypeTurn) === tt,
        );
        const after = this.localTurns.find((t) => Number(t.TypeTurn) === tt);
        const bQty = before ? Number(before.WprQuantityProject) : 0;
        const aQty = after ? this.getTurnTotal(after) : 0;
        if (bQty !== aQty) return true;
      }
      return false;
    },
    changeDiffs() {
      const allTurnTypes = new Set([
        ...this.beforeSnapshot.map((s) => Number(s.TypeTurn)),
        ...this.localTurns.map((t) => Number(t.TypeTurn)),
      ]);
      const diffs = [];
      for (const tt of allTurnTypes) {
        const before = this.beforeSnapshot.find(
          (s) => Number(s.TypeTurn) === tt,
        );
        const after = this.localTurns.find((t) => Number(t.TypeTurn) === tt);
        const bQty = before ? Number(before.WprQuantityProject) : 0;
        const aQty = after ? this.getTurnTotal(after) : 0;
        if (bQty !== aQty || !before || !after) {
          diffs.push({
            turnName: this.getTurnName(tt),
            before: bQty,
            after: aQty,
            delta: aQty - bQty,
          });
        }
      }
      return diffs;
    },
    totalDelta() {
      return this.newGrandTotal - this.beforeTotal;
    },
    isValid() {
      if (this.mode === "add" && !this.localPdsID) return false;
      if (this.localTurns.length === 0) return false;
      if (this.newGrandTotal <= 0) return false;
      if (this.newGrandTotal > this.reqQuantity) return false;
      // Check all turns have a type selected
      const hasInvalidTurn = this.localTurns.some((t) => !t.TypeTurn);
      if (hasInvalidTurn) return false;
      // Check no duplicate turn types
      const types = this.localTurns.map((t) => Number(t.TypeTurn));
      const unique = new Set(types);
      if (unique.size !== types.length) return false;
      return true;
    },
  },
  watch: {
    visible(val) {
      if (val) this.initForm();
    },
  },
  methods: {
    initForm() {
      this.periodError = "";
      if (this.mode === "edit" && this.weekData) {
        // Deep clone the turns for editing
        this.localTurns = (this.weekData.turns || []).map((t) => ({
          WprID: t.WprID || 0,
          TypeTurn: t.TypeTurn,
          WprQuantityProject: Number(t.WprQuantityProject) || 0,
          WprQuantityMale: Number(t.WprQuantityMale) || 0,
          WprQuantityFemale: Number(t.WprQuantityFemale) || 0,
          SecStatus: 1,
          ReqID: t.ReqID || this.computedReqId,
          PdsID: t.PdsID || this.weekData.PdsID,
        }));
        // Snapshot for comparison
        this.beforeSnapshot = (this.weekData.turns || []).map((t) => ({
          TypeTurn: t.TypeTurn,
          WprQuantityProject: Number(t.WprQuantityProject) || 0,
          WprQuantityMale: Number(t.WprQuantityMale) || 0,
          WprQuantityFemale: Number(t.WprQuantityFemale) || 0,
        }));
        this.localPdsID = this.weekData.PdsID;
      } else {
        // Add mode - start with one empty turn
        this.localTurns = [
          {
            WprID: 0,
            TypeTurn: 1,
            WprQuantityProject: 1,
            WprQuantityMale: 1,
            WprQuantityFemale: 0,
            SecStatus: 1,
            ReqID: this.computedReqId,
            PdsID: null,
          },
        ];
        this.beforeSnapshot = [];
        this.localPdsID = null;
      }
    },
    getTurnName(typeTurn) {
      const t = Number(typeTurn);
      if (t === 1) return "Día";
      if (t === 2) return "Noche";
      return "Mixto";
    },
    getTurnTotal(turn) {
      return (
        (Number(turn.WprQuantityMale) || 0) +
        (Number(turn.WprQuantityFemale) || 0)
      );
    },
    onMaleChange(turn) {
      const male = Math.max(0, Number(turn.WprQuantityMale) || 0);
      const female = Math.max(0, Number(turn.WprQuantityFemale) || 0);
      turn.WprQuantityMale = male;
      turn.WprQuantityProject = male + female;
    },
    onFemaleChange(turn) {
      const male = Math.max(0, Number(turn.WprQuantityMale) || 0);
      const female = Math.max(0, Number(turn.WprQuantityFemale) || 0);
      turn.WprQuantityFemale = female;
      turn.WprQuantityProject = male + female;
    },
    addTurn() {
      // Find a turn type not yet used
      const usedTypes = this.localTurns.map((t) => Number(t.TypeTurn));
      let newType = null;
      for (const candidate of [1, 2, 3]) {
        if (!usedTypes.includes(candidate)) {
          newType = candidate;
          break;
        }
      }
      if (newType === null) return;

      this.localTurns.push({
        WprID: 0,
        TypeTurn: newType,
        WprQuantityProject: 0,
        WprQuantityMale: 0,
        WprQuantityFemale: 0,
        SecStatus: 1,
        ReqID: this.reqID,
        PdsID: this.localPdsID || (this.weekData ? this.weekData.PdsID : null),
      });
    },
    removeTurn(index) {
      const turn = this.localTurns[index];
      if (turn.WprID > 0) {
        // Mark for deletion instead of splicing
        turn.SecStatus = 0;
        turn.WprQuantityProject = 0;
        turn.WprQuantityMale = 0;
        turn.WprQuantityFemale = 0;
        // Remove from visible array but keep in a separate deletedTurns tracker
        if (!this._deletedTurns) this._deletedTurns = [];
        this._deletedTurns.push({ ...turn });
        this.localTurns.splice(index, 1);
      } else {
        this.localTurns.splice(index, 1);
      }
    },
    onPeriodChange(pdsID) {
      this.periodError = "";
      if (!pdsID) return;

      const period = this.periodsList.find(
        (p) => String(p.PdsID) === String(pdsID),
      );
      if (!this.$fun.isAdmin() && period) {
        // Check if frozen
        const datePart = String(period.PdsDateBegin).slice(0, 10);
        const [year, month, day] = datePart.split("-").map(Number);
        const beginDate = new Date(year, month - 1, day, 0, 0, 0, 0);
        const limitDate = new Date(
          beginDate.getTime() - 4 * 24 * 60 * 60 * 1000,
        );
        if (new Date() >= limitDate) {
          this.periodError = "Este periodo ya está congelado.";
          this.localPdsID = null;
          return;
        }
      }
      // Set PdsID on all turns
      this.localTurns.forEach((t) => {
        t.PdsID = pdsID;
      });
    },
    close() {
      this._deletedTurns = [];
      this.$emit("update:visible", false);
      this.$emit("close");
    },
    save() {
      if (!this.isValid) return;

      // Build payload: merge visible turns + deleted turns
      const allTurns = [
        ...this.localTurns.map((t) => ({
          ...t,
          PdsID: this.localPdsID || t.PdsID,
          WprQuantityProject: this.getTurnTotal(t),
        })),
        ...(this._deletedTurns || []),
      ];

      const payload = {
        pdsID: this.localPdsID || (this.weekData ? this.weekData.PdsID : null),
        weekName:
          this.mode === "add" ? this.getSelectedPeriodName() : this.weekName,
        turns: allTurns,
        before: {
          turns: this.beforeSnapshot,
          total: this.beforeTotal,
        },
        after: {
          total: this.newGrandTotal,
          male: this.newTotalMale,
          female: this.newTotalFemale,
        },
      };

      this._deletedTurns = [];
      this.$emit("on-save", payload);
    },
    getSelectedPeriodName() {
      if (!this.localPdsID) return "Nueva Semana";
      const period = this.periodsList.find(
        (p) => String(p.PdsID) === String(this.localPdsID),
      );
      return period ? period.PdsName : `Semana ${this.localPdsID}`;
    },
  },
  created() {
    this._deletedTurns = [];
  },
};
</script>

<style scoped>
/* ── Dialog ──────────────────────────── */
.week-form-card {
  border-radius: 14px !important;
  overflow: hidden;
}

/* ── Header ──────────────────────────── */
.wf-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 22px;
}

.wf-header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.wf-header-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wf-header-icon--edit {
  background: linear-gradient(135deg, #3b5bdb 0%, #5b7cf7 100%);
}

.wf-header-icon--add {
  background: linear-gradient(135deg, #10b981 0%, #34d399 100%);
}

.wf-title {
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  line-height: 1.3;
}

.wf-subtitle {
  font-size: 12px;
  color: #94a3b8;
  font-weight: 400;
}

/* ── Body ────────────────────────────── */
.wf-body {
  padding: 20px 22px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  max-height: 65vh;
  overflow-y: auto;
}

/* ── Period Selector ─────────────────── */
.wf-period-selector {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.wf-field-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #94a3b8;
}

.wf-field-error {
  font-size: 11px;
  color: #ef4444;
  font-weight: 500;
}

/* ── Before Panel ────────────────────── */
.wf-before-panel {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 14px 16px;
}

.wf-panel-label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #94a3b8;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.wf-before-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
}

.wf-before-item {
  display: flex;
  align-items: center;
  gap: 2px;
  font-size: 12px;
  color: #475569;
}

.before-turn-name {
  font-weight: 600;
}

.before-turn-qty {
  font-weight: 700;
  color: #1e293b;
  margin: 0 2px;
}

.before-turn-split {
  font-size: 11px;
  color: #94a3b8;
}

.wf-before-total {
  font-size: 12px;
  color: #64748b;
  padding-left: 8px;
  border-left: 2px solid #e2e8f0;
  font-weight: 500;
}

/* ── Edit Section ────────────────────── */
.wf-edit-section {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 16px;
}

.wf-edit-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.add-turn-btn {
  text-transform: none;
  font-weight: 600;
  font-size: 11px;
  border-radius: 6px;
}

/* ── Turns Table ─────────────────────── */
.wf-turns-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.wf-turns-table th {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #94a3b8;
  padding: 6px 8px;
  border-bottom: 2px solid #e2e8f0;
}

.wf-turn-row td {
  padding: 8px;
  vertical-align: middle;
  border-bottom: 1px solid #f1f5f9;
}

.wf-qty-input {
  max-width: 90px;
  margin: 0 auto;
}

.wf-qty-input >>> input {
  text-align: center;
  font-weight: 600;
}

.wf-turn-total {
  font-size: 14px;
  font-weight: 800;
  color: #1e293b;
}

/* ── Totals Footer ───────────────────── */
.wf-totals-footer {
  background: #f8fafc;
  border-top: 2px solid #e2e8f0;
}

.wf-totals-footer td {
  padding: 10px 8px;
  color: #1e293b;
}

.wf-grand-total {
  font-size: 16px;
  font-weight: 800;
  color: #10b981;
}

.wf-grand-over {
  color: #ef4444 !important;
}

/* ── Limit Bar ───────────────────────── */
.wf-limit-bar {
  height: 4px;
  background: #f1f5f9;
  border-radius: 4px;
  overflow: hidden;
  margin-top: 12px;
}

.wf-limit-fill {
  height: 100%;
  border-radius: 4px;
  transition: width 0.3s ease, background 0.3s ease;
}

.wf-limit-fill--ok {
  background: linear-gradient(90deg, #10b981 0%, #34d399 100%);
}

.wf-limit-fill--over {
  background: linear-gradient(90deg, #ef4444 0%, #f87171 100%);
}

.wf-limit-text {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 6px;
  font-size: 11px;
  color: #94a3b8;
  font-weight: 500;
}

/* ── Comparison Panel ────────────────── */
.wf-comparison-panel {
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 10px;
  padding: 14px 16px;
}

.wf-comparison-grid {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.wf-diff-item,
.wf-diff-total {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  padding: 4px 0;
}

.wf-diff-total {
  border-top: 1px solid #fde68a;
  padding-top: 8px;
  margin-top: 4px;
}

.diff-turn {
  min-width: 60px;
  font-weight: 600;
  color: #475569;
}

.diff-before {
  color: #94a3b8;
  font-weight: 500;
  text-decoration: line-through;
}

.diff-after {
  color: #1e293b;
  font-weight: 700;
}

/* ── New Note ────────────────────────── */
.wf-new-note {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #3b5bdb;
  font-weight: 500;
  background: #eef2ff;
  border: 1px solid #c7d2fe;
  border-radius: 8px;
  padding: 10px 14px;
}

/* ── Footer ──────────────────────────── */
.wf-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 22px;
}

.wf-btn {
  text-transform: none;
  font-weight: 600;
  border-radius: 8px;
  letter-spacing: 0.01em;
}

.wf-btn--save {
  min-width: 160px;
}
</style>
